import { useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000";

export const useDashboardData = () => {
  const [summary, setSummary] = useState(null);
  const [trend, setTrend] = useState([]);
  const [topCustomers, setTopCustomers] = useState([]);
  const [topProducts, setTopProducts] = useState([]);
  
  // MODIFIED: Update initial state to match the new MoM response structure
  const [mom, setMoM] = useState({
    sales: { series: [], mom: { current: 0, previous: 0, pct_change: null } },
    profit: { series: [], mom: { current: 0, previous: 0, pct_change: null } },
  });
  const [fy, setFY] = useState([]);
  const [lifetime, setLifetime] = useState(null);

  // REMOVED: The separate profitSummary state is no longer needed.
  // const [profitSummary, setProfitSummary] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAll = async () => {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };

      try {
        const [
          summaryRes,
          trendRes,
          customersRes,
          productsRes,
          momRes,
          fyRes,
          lifeRes,
          // REMOVED: profitRes is no longer fetched separately
        ] = await Promise.all([
          axios.get(`${API_BASE}/reports/summary`, { headers }),
          axios.get(`${API_BASE}/reports/sales-trend`, { headers }),
          axios.get(`${API_BASE}/reports/top-customers`, { headers }),
          axios.get(`${API_BASE}/reports/top-products`, { headers }),
          axios.get(`${API_BASE}/reports/month-over-month?months=6`, { headers }),
          axios.get(`${API_BASE}/reports/financial-year-sales`, { headers }),
          axios.get(`${API_BASE}/reports/lifetime`, { headers }),
          // REMOVED: The API call to /profit-summary is gone
        ]);

        setSummary(summaryRes.data);
        setTrend(trendRes.data);
        setTopCustomers(customersRes.data);
        setTopProducts(productsRes.data);
        setMoM(momRes.data);
        setFY(fyRes.data);
        setLifetime(lifeRes.data);
        // REMOVED: The separate state setter is gone
        
      } catch (err) {
        console.error("Dashboard fetch failed:", err);
        setError(
          "Failed to load dashboard data. Please ensure the server is running and you are logged in."
        );
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, []);

  return {
    summary,
    trend,
    topCustomers,
    topProducts,
    mom,
    fy,
    lifetime,
    // REMOVED: profitSummary is no longer returned from this hook
    loading,
    error,
  };
};
